import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_SUPPORT_FILTER, GET_SUPPORT_FILTER_SUCCESS, GET_SUPPORT_FILTER_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getSupportFilter({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId, sortBy, source } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/support-tickets`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_SUPPORT_FILTER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SUPPORT_FILTER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SUPPORT_FILTER_ERROR, payload: error });
  }
}

export function* watchGetSupportFilter() {
  yield takeEvery(GET_SUPPORT_FILTER, getSupportFilter);
}

function* getSupportFilterSaga() {
  yield all([fork(watchGetSupportFilter)]);
}

export default getSupportFilterSaga;
